import { Markdown } from "@tiptap/markdown";

/**
 * Markdown in/out for the chat composer.
 *
 * - Single newlines parse as line breaks, matching how chat messages render.
 * - Plain text is emitted exactly as typed. The default serializer escapes
 *   markdown characters and HTML entities (`file_name` → `file\_name`,
 *   `Q&A` → `Q&amp;A`), which would leak into notifications and other
 *   plain-text consumers of the message.
 */
export const ChatMarkdown = Markdown.extend({
  onBeforeCreate(event) {
    this.parent?.(event);
    Object.assign(this.storage.manager, {
      encodeTextForMarkdown: (text: string) => text,
    });
  },
}).configure({
  markedOptions: { breaks: true, gfm: true },
});
